import { render, staticRenderFns } from "./StorePhotos.vue?vue&type=template&id=0225e74e&scoped=true"
import script from "./StorePhotos.vue?vue&type=script&lang=js"
export * from "./StorePhotos.vue?vue&type=script&lang=js"
import style0 from "./StorePhotos.vue?vue&type=style&index=0&id=0225e74e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0225e74e",
  null
  
)

export default component.exports